import { Inject, Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ConfType, DriverName } from '@models/*';
import { RestService } from '../../core/services/rest.service';
import { ToastService } from '../../core/services/toast.service';
import { ErrorService } from '../../core/services/error.service';
import { NetworkService } from '../../core/services/network.service';
import { APP_CONFIG, AppConfig } from '../../config/app-config';

@Injectable({
    providedIn: 'root'
})
export class DriverService extends RestService {
  constructor(
    @Inject(APP_CONFIG) appConfig: AppConfig,
    private toastService: ToastService,
    http: HttpClient,
    errorService: ErrorService,
    networkService: NetworkService,
    injector: Injector,
  ) {
    super(appConfig, http, errorService, networkService, injector);
  }

    getNames(): Observable<DriverName[]> {
        return this.get(`${this.GET_DRIVER_NAMES_URL}`)
            .pipe(
                map(res => (res instanceof HttpErrorResponse || res.error) ? [] : res.data)
            );
    }

    addName(payload: any): Observable<any> {
        return this.post(`${this.ADD_DRIVER_NAME_URL}`, payload)
            .pipe(
                tap(res => {
                    if (res && res.status && JSON.parse(res.status) && !res.error) {
                        this.toastService.generateSuccessToast(ConfType.NAME_ADDED);
                    }
                }),
                map(res => (res instanceof HttpErrorResponse || res.error) ? [] : res.data)
            );
    }

    setDriverLanguage(payload: { language: string }): Observable<any> {
        return this.post(`${this.SET_LANG_URL}`, payload, null, true)
            .pipe(
                map(res => (res instanceof HttpErrorResponse || res.error) ? null : res.data)
            );
    }
}
